export type MenuItem = {
  section: string;
  label: string;
  icon: string;
  route: string;
  isExternal: boolean;
};

export const MENU_ITEMS: MenuItem[] = [
  {
    section: 'DATA & ANALYSIS',
    label: 'General Overview',
    icon: 'grid_view',
    route: '/dashboard',
    isExternal: false,
  },
  {
    section: 'DATA & ANALYSIS',
    label: 'Data Hub & Intraday',
    icon: 'public',
    route: 'https://www.energymarketprice.com/data-hub',
    isExternal: true,
  },
  {
    section: 'DATA & ANALYSIS',
    label: 'Prophet & Market Validation',
    icon: 'rocket',
    route: 'https://www.energymarketprice.com/forecasts',
    isExternal: true,
  },
  {
    section: 'DATA & ANALYSIS',
    label: 'Market News & Insight',
    icon: 'rss_feed',
    route: '/market-news',
    isExternal: false,
  },
  {
    section: 'DATA & ANALYSIS',
    label: 'Data Shooter (API)',
    icon: 'target',
    route: '/data-shooter',
    isExternal: false,
  },
  {
    section: 'ENTERPRISE SOLUTIONS',
    label: 'Cockpit Hub',
    icon: 'dashboard',
    route: 'https://cockpit.energymarketprice.com',
    isExternal: true,
  },
  {
    section: 'ENTERPRISE SOLUTIONS',
    label: 'Contract Management (EMO)',
    icon: 'assignment',
    route: 'https://emo.energymarketprice.com',
    isExternal: true,
  },
  {
    section: 'ENTERPRISE SOLUTIONS',
    label: 'Budget & Scenario Reports',
    icon: 'bar_chart',
    route: 'https://esmart.energymarketprice.com/',
    isExternal: true,
  },
  {
    section: 'PLATFORMS & USERS',
    label: 'Metering Data Lake',
    icon: 'storage',
    route: 'https://datalake.energymarketprice.com',
    isExternal: true,
  },
  {
    section: 'PLATFORMS & USERS',
    label: 'Customer Analytics',
    icon: 'analytics',
    route: 'https://www.energymarketprice.com/cockpit-analytics',
    isExternal: true,
  },
  {
    section: 'PLATFORMS & USERS',
    label: 'Users & Team',
    icon: 'group',
    route: '/users-team',
    isExternal: false,
  },
];
